<template>
  <v-layout justify-center align-center fill-height pl-2 pt-4 pr-2 pb-2 row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h2>Edit Corporate Customer</h2>
          </v-flex>
          <v-flex xs12 pl-1>
            <h3>Business User</h3>
          </v-flex>
          <v-flex xs12 md12>
            <UserForm
              v-if="!loading"
              ref="userForm"
              :disabled="disabled"
              :user="user"
              :errors="errors.user"
              @validityChange="updateFormValidity('user', $event)"
              :editingUser="true"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 pl-1 pt-2>
            <h3>Business Information</h3>
          </v-flex>
          <v-flex xs12 md12>
            <BusinessForm
              v-if="!loading"
              ref="businessForm"
              :disabled="disabled"
              :paymentTypes="paymentTypesList"
              :business="business"
              :errors="errors.business"
              @validityChange="updateFormValidity('business', $event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12 pt-1>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="update" class="text-none" :disabled="disabled">Update</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/customer/UserForm.vue";
import BusinessForm from "@/components/corporateCustomer/BusinessForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "edit_corporate_customer",
  components: {
    SimpleCard,
    UserForm,
    BusinessForm,
  },
  data: function () {
    return {
      user: null,
      business: null,
      paymentTypes: {},
      paymentTypesList: [],
      errors: {},
      userFormValid: false,
      businessFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      loading: true,
      disabled: true,
    };
  },
  mounted: function () {
    let self = this;
    Promise.all([this.getPaymentTypes(), this.getBusinessInfo()]).then(
      function (success) {
        console.log(success);
        if (success[0] && success[1]) {
          self.disabled = false;
        }
        self.loading = false;
      }
    );
  },
  methods: {
    getPaymentTypes: async function () {
      let url = `${this.$store.state.apiUrl}/corporateCustomer/getPaymentTypes`;
      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          this.snackbarMessage =
            "Failed to get information to edit corporate customer";
          this.snackbarColour = "error";
          this.snackbarShow = true;
        } else {
          if (response.data.paymentTypes) {
            this.paymentTypes = response.data.paymentTypes;

            return true;
          } else {
            this.snackbarMessage =
              "Failed to get information to edit corporate customer";
            this.snackbarColour = "error";
            this.snackbarShow = true;
          }
        }

        return false;
      } catch (error) {
        console.log(error);
        this.snackbarMessage =
          "Failed to get information to edit corporate customer";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        return false;
      }
    },
    getBusinessInfo: async function () {
      let url = `${this.$store.state.apiUrl}/corporateCustomer/${this.$route.params.id}/get`;

      try {
        const response = await axios.get(url);

        if (!response.error) {
          if (response.data.user && response.data.business) {
            this.user = response.data.user;
            this.business = response.data.business;
            this.user.password = "";

            return true;
          } else {
            this.user = {};
            this.business = {};
            this.snackbarMessage = "Error fetching corporate customer, no data";
            this.snackbarColour = "error";
            this.snackbarShow = true;
          }
        } else {
          console.log(response.error);
          this.user = {};
          this.business = {};
          this.snackbarMessage =
            "Error fetching corporate customer: " + response.error;
          this.snackbarColour = "error";
          this.snackbarShow = true;
        }

        return false;
      } catch (error) {
        console.log(error);
        this.user = {};
        this.business = {};
        this.snackbarMessage = error;
        this.snackbarColour = "error";
        this.snackbarShow = true;

        return false;
      }
    },
    update: async function () {
      delete this.user["loyalty_tier"];
      delete this.user["loyalty_point_summary"];

      if (this.userFormValid & this.businessFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/corporateCustomer/${this.$route.params.id}/update`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            business: this.business,
          },
          headers: {
            "Content-Type": "text/plain",
          },
        })
          .then(function (response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error updating corporate customer, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error updating corporate customer: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const businessID = response.data.business.id;
              self.$router.push("../../corporateCustomer/view/" + businessID);
            }
          })
          .catch(function (error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
        this.$refs.BusinessForm.validateForm();
      }
    },
    updateFormValidity: function (form, value) {
      switch (form) {
        case "user":
          this.userFormValid = value;
          break;
        case "business":
          this.businessFormValid = value;
          break;
      }
    },
  },
  watch: {
    paymentTypes: function () {
      this.paymentTypesList = [];
      for (const key in this.paymentTypes) {
        this.paymentTypesList.push({
          key: key,
          name: this.paymentTypes[key],
        });
      }
    },
  },
};
</script>